import { Validators } from 'core/services/Validators';
import { computed, makeAutoObservable } from 'mobx';
import { FormControl, FormGroup } from 'shared/libs/form';
import { AsyncState } from 'shared/libs/state';
import { ApiResponseDto } from 'shared/types';
import { JobApplicantsStore } from '../job-applicatns-store';
import { JobApplicantsApiService } from '../JobApplicantsApiService';

export class ApplicantsSendEmailStore {
   private readonly emailState = new AsyncState<ApiResponseDto<string>>();

   readonly form = new FormGroup({
      subject: new FormControl<string>('', [Validators.required]),
      message: new FormControl<string>('', [Validators.required]),
   });

   constructor(private readonly jobApplicants: JobApplicantsStore) {
      makeAutoObservable(this, {
         emailSending: computed,
      });
   }

   get emailSending() {
      return this.emailState.status === 'pending';
   }

   public submit(opt: { onSuccess?: (res: any) => void; onError?: (e: any) => void } = {}): void {
      this.form.validate();
      if (this.form.valid) {
         this.sendEmail(opt);
      }
   }

   async sendEmail({
      onSuccess,
      onError,
   }: { onSuccess?: (res: any) => void; onError?: (e: any) => void } = {}): Promise<void> {
      const emails = this.jobApplicants.selectedCandidates.map((c) => c.email_address).join(',');
      const jobId = this.jobApplicants.jobInfo?.job_id;

      if (emails && jobId) {
         await this.emailState.run(
            () =>
               JobApplicantsApiService.sendEmailToCandidates({
                  job_id: jobId,
                  email_address: emails,
                  message: this.form.controls['message'].value,
                  subject: this.form.controls['subject'].value,
               }),
            {
               onSuccess: (res) => {
                  if (res) {
                     onSuccess?.(res);
                  }
               },
               onError: (e) => {
                  onError?.(e);
               },
            }
         );
      }
   }
}
